import GetTicketButton from './GetTicketButton'

export default GetTicketButton
